import styled from '@emotion/styled';

import { dustyOrangeTwo, fontWeight } from '~/styles';

export const Container = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
  justify-content: center;
  height: 91px;
  background: #f7f7f7;
`;

export const IconGroupWrapper = styled.div`
  display: flex;
  gap: 16px;
  @media print {
    display: none;
  }
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: ${fontWeight.regular};
  line-height: 21px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;
export const IconWrapper = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OrangeIconWrapper = styled(IconWrapper)`
  background: ${dustyOrangeTwo};
  border-radius: 14px;
`;

export const LinkIconWrapper = styled(OrangeIconWrapper)`
  transform: rotate(-45deg);
`;

export const Button = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
`;
